export default __webpack_public_path__ + "static/media/498.52df4462.png";